export default "__VITE_ASSET__386311c2__"